export default {
    period: 'Period',
    account: 'Account',
    password: 'Password',
    cameraCode: 'Camera Code',
    organizationName: 'Organization Name',
    organizationAcronym: 'Abbreviations',
    fullAddress: 'Full Address',
    houseNumber: 'House Number',
    street: 'Street',
    zipCode: 'Zip Code',
    adminAccount: 'Admin Account',
    phoneNumber: 'Phone Number',
    organizationType: 'Type of organization',
    expiredDate: 'Expired Date',
    organizationBranchName: ' Branch Name',
    cameraName: 'Camera Name',
    streamUrl: 'Link stream',
    employeeCode: 'Employee code',
    LastName: 'LastName',
    FirstName: 'FirstName',
    birthday: 'Date of birth',
    type: 'Type',
    deviceType: 'ASSET',
    brand: 'Brand',
    model: 'Code',
    serialNumber: 'Serial number',
    totalQuantity: 'Total quantity',
    importDate: 'Date Added',
    supplier: 'Supplier',
    fromDate: 'From Date',
    toDate: 'To Date',
    assignDate: 'Date of issue',
    reason: 'Reason',
    workShiftName: 'Work shift name',
    workDayOfWeek: 'Working day',
    startHour: 'Start hour',
    endHour: 'End hour',
    bufferTime: 'Flex time',
    groupName: 'Group name',
    allowCheckInBefore: 'Allow CheckIn Before',
    allowCheckInAfter: 'Allow CheckIn After',
    allowCheckOutBefore: 'Allow Check Out Before',
    allowCheckOutAfter: 'Allow Check Out After',
    equipmentType: 'Item name',
    dailyWorkName: 'Work name',
    startDate: 'Start date',
    endDate: 'End date',
    dailyWorkDetailName: "Item Name",
    methodCheck: "Method",
    completionCriteria: "Job requirements",
    placeDetailName: "Place name",
    level: "Priority level",
    address: "Full Address",
    areaDetailName: "Area name",
    nameRestrictedarea: "Event name",
    fromHour: "From hour",
    toHour: "To hour",
    date: "Timekeeping complaint date",
    newPassword: "New Password",
    cameraGroupName: "Group Name",
    qrCode: "QR code",
    titleNotify: "Insert title",
    abbreviate: "Insert abbreviate",
    name: "Name of meeting room",
    location: 'Location',
    reservationName: "Meeting name",
    purpose: "Purpose",
    dateBegin: "Meeting date",
    meetingRoom: "Meeting room",
    participants: 'Participants',
    timeKeepingType: 'Partner',
    oldPassWord: 'Old passWord',
    newPassWord: 'New passWord',
    reNewPassWord: 'Re-enter a new password',
    title: 'Title',
    typeForNewsEvent: 'Topic',
    email: 'Email',
    rePassword: 'Password',
    fullName: 'Full Name',
    lastName: 'Last Name',
    firstName: 'First Name',
    userName: 'User Name',
    functionName: 'Function Name',
    salary: 'Salary',
    enterAddress: 'Location',
    streetName: 'Building, Street Name',
    startWork: 'Work Start',
    employee: 'Employee',
    position: 'Position',
    branch: 'Branch',
    codeCustomer: 'Customer code',
    dayOfBirth: 'Day of birth',
    gender: 'Gender',
    identityCard: 'Identity card',
    nameServiceType: 'Service name',
    codeServiceType: 'Service code',
    nameServicePacks: 'Service package name',
    codeServicePacks: 'Service package code',
    time: 'Time',
    unit: 'Unit',
    unitPrice: 'Unit price',
    departmentName: 'Department name',
    codeCombo: 'Code combo service',
    nameCombo: 'Name combo service',
    customer: 'Customer',
    ethnic: 'Ethnic',
    reply: 'Reply',
    branchType: 'Type branch',
    sourceType: 'Source customer',
    nameIconApp: 'Workspace Name',
    urlApp: 'Workspace Url',
    ordersApp: 'Workspace Order',
    nameCardClass: 'Card class name',
    cardMilestone: 'Card point',
    groupName:'Group name',
    manager:'Manager',
    employee:'Employee',
}
